module.exports = __webpack_public_path__ + "assets/img/12_104.6a64e824.jpg";